import useDeleteUnidadePessoa from "core/features/unidades/useDeleteUnidadePessoa";
import useUnidadePessoas from "core/features/unidades/useUnidadePessoas";
import {
  showConfirm2,
  showErrorAxios,
  showError,
  showSuccess,
} from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import NewTable from "components/NewTable";
import TabPessoasTableHeader from "./TabPessoasTableHeader";
import { useLoading } from "components/GlobalLoading";
import useTabelaPessoaColumns from "../../hooks/useTabelaPessoaColumns";
import { PessoaTipo } from "core/features/pessoas/typings";
import UnidadeEvents from "./events";
import useReenvioEmailSenha from "core/features/usuario/hooks/useReenvioEmailSenha";
import { useLocation } from "react-router-dom";

function TabelaUnidadePessoas({
  unidadeId,
  onEdit,
  onCreate,
  onChangeProprietario,
  refreshDate,
}: {
  unidadeId: string;
  onEdit: (id: string, pessoaTipo: PessoaTipo) => void;
  onCreate: (pessoaTipo: PessoaTipo) => void;
  onChangeProprietario: () => void;
  refreshDate: number | null;
}) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const highlightParam = params.get("highlight") as string;

  const { mutate: reenvioEmailSenha, isLoading: isLoadingReenviar } =
    useReenvioEmailSenha();

  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching, refetch } = useUnidadePessoas({
    unidadeId,
    page,
  });

  const columns = useTabelaPessoaColumns({
    unidadeId,
    onToogled: () => {
      refetch();
    },
  });

  useEffect(() => {
    if (refreshDate) {
      refetch();
    }
  }, [refreshDate, refetch]);

  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteUnidadePessoa(unidadeId);

  useLoading(isLoadingDelete || isLoadingReenviar);

  return (
    <>
      <NewTable
        title={() => (
          <TabPessoasTableHeader
            onChangeProprietario={onChangeProprietario}
            onCreate={onCreate}
            totalPages={data?.meta.totalPages!}
          />
        )}
        highlight={highlightParam}
        loading={isLoading || isFetching}
        dataSource={data?.items ?? []}
        onRow={(v) => ({
          style: {
            cursor: "pointer",
          },
          onClick: (ev) => {
            if (
              (ev.target as HTMLElement)?.className?.includes("chakra-switch")
            ) {
              return;
            }

            onEdit(v.id, v.pessoaTipo);
          },
        })}
        actions={[
          {
            title: "Editar",
            onClick: (v) => {
              onEdit(v.id, v.pessoaTipo);
            },
          },
          {
            title: "Reenviar e-mail com senha",
            onClick: (data) => {
              if (!data.usuarioId) {
                showError("Esta pessoa não tem email cadastrado");
                return;
              }
              reenvioEmailSenha(
                {
                  users: [data.usuarioId],
                  type: "email",
                },
                {
                  onSuccess: () => showSuccess(),
                }
              );
              UnidadeEvents.reenviarEmailSenhaEvent(data.id);
            },
          },
          {
            title: "Excluir",
            onClick: (v) => {
              showConfirm2({
                onOk: () => {
                  handleDelete(v.id, {
                    onSuccess: async () => {
                      await showSuccess();
                      if (page > 1) {
                        setPage(1);
                      } else {
                        refetch();
                      }
                    },
                    onError: (err) => {
                      showErrorAxios(err);
                    },
                  });
                },
              });
            },
          },
        ]}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          onChangePage: (p) => setPage(p),
        }}
        columns={columns}
      />
    </>
  );
}

export default TabelaUnidadePessoas;
